import React, {useContext} from "react";
import {FormContext} from "@proxy/_contexts";
import {Modal, VideoRecorder} from "@proxy/_components";

export default function RecordingModal() {

  const { styleVars, enableCamera } = useContext(FormContext);

  return (
    <Modal
      id="gcpVideoRecordingModal"
      title="Record a video message"
      open={enableCamera}
    >
      <div style={styleVars} className="gc__modal-1-content">
        <VideoRecorder />
      </div>
    </Modal>
  );
};
